import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'vsc-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NotFoundComponent {
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {}

    navigateToHome(): void {
        this.router.navigate(['../home'], { relativeTo: this.activatedRoute });
    }
}
